import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import { LogIn } from "lucide-react";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("admin_token", data.token);
            localStorage.setItem("admin_email", data.admin.email);
            toast.success("Bienvenido");
            navigate("/admin");
        } catch (err) {
            toast.error(formatApiErrorDetail(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    }

    return (
        <div
            className="min-h-screen flex items-center justify-center bg-ivory px-6 py-20"
            data-testid="admin-login-page"
        >
            <div className="w-full max-w-md bg-white rounded-xl border border-border-soft/40 p-10">
                <div className="text-center">
                    <p className="overline">Panel de administración</p>
                    <h1 className="font-serif text-4xl text-charcoal mt-3">Bienvenida</h1>
                    <p className="text-taupe text-sm mt-2">Inicia sesión para gestionar tu tienda.</p>
                </div>
                <form onSubmit={handleSubmit} className="mt-8 space-y-4" data-testid="login-form">
                    <div>
                        <label className="overline block mb-2">Correo</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="w-full bg-white border border-border-soft rounded-md px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-rose"
                            data-testid="admin-login-email"
                        />
                    </div>
                    <div>
                        <label className="overline block mb-2">Contraseña</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="w-full bg-white border border-border-soft rounded-md px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-rose"
                            data-testid="admin-login-password"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-rose text-white hover:bg-rose-dark rounded-full px-8 py-3.5 transition-colors text-xs tracking-[0.2em] uppercase inline-flex items-center justify-center gap-2 disabled:opacity-50"
                        data-testid="admin-login-submit"
                    >
                        <LogIn strokeWidth={1.5} className="w-4 h-4" />
                        {loading ? "Entrando..." : "Iniciar sesión"}
                    </button>
                </form>
            </div>
        </div>
    );
}
